<div class="spinner-border spinner" role="status" [ngStyle]="{ color }">
  <span class="visually-hidden">Loading...</span>
</div>
